import _, { result } from 'underscore';
import { BaseSurvey } from '../base-survey';
import { ReportingWebuiUserSurveyView } from './view';

const reportingLastTimeVisited = 'ReportingLastTimeVisited';

export class ReportingWebuiUserSurvey extends BaseSurvey {
  getSurveyName = () => 'ReportingSurvey';

  getSurveyId = isTestEnv => isTestEnv ? // eslint-disable-line no-confusing-arrow
    '5db23eb6-b692-46fa-b86e-96547e020e4d' : '08144017-cf15-45b3-be82-36a6842144ae';

  getSurveyProduct = () => 'Reporting';

  getSurveyInterface = () => 'Web';

  getInitializationConfig = () => ({
    initGroup: 100,
    initStartDate: '2024-07-15',
    initEndDate: '2025-07-15',
  });

  validateTriggerCondition = () => {
    const reportingLastTimeVisitedObj = this.SurveyPreferenceService.getAtUserLevel(reportingLastTimeVisited);
    const lastTimeVisited = _.get(reportingLastTimeVisitedObj, 'Data');

    if (_.isUndefined(lastTimeVisited)) {
      return false;
    }

    // Check to see if the user has visited reporting in the last 30 days
    if ((Date.now() - lastTimeVisited) > (30 * 24 * 60 * 60 * 1000)) {
      return false;
    }

    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Start`);

    // should not be AAD users, AAD users can be included in the future after OCPS integration
    const isNonAADUser = !result(this.serverContext, 'IsAADUser');

    if (!isNonAADUser) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isNonAADUser: ${isNonAADUser}`);
      return false;
    }

    // should be active user more than 30 days
    const userCreatedDateTime = new Date(result(this.serverContext, ['CurrentUser', 'CreatedDateTime']));
    const surveyPreference30DaysAgo = this.SurveyPreferenceService.getDaysAgo(30);
    const isUserActiveOneMonth = userCreatedDateTime <= surveyPreference30DaysAgo;

    if (!this.isTestEnv && !isUserActiveOneMonth) {
      this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, isTestEnv: ${this.isTestEnv}, isUserActiveOneMonth: ${isUserActiveOneMonth}, userCreatedDateTime: ${userCreatedDateTime}, surveyPreference30DaysAgo: ${surveyPreference30DaysAgo}`);
      return false;
    }
    const surveyHasCooledDown = this.validateUserGovernance();

    if (!surveyHasCooledDown) {
      return false;
    }

    // conditions copied from Qualtrics
    const isEnglishUser = result(this.serverContext, ['CurrentUser', 'Language']) === 'EN';
    const isNotInternalUser = result(this.serverContext, ['CurrentUser', 'IsInternal']) !== true;
    const isNotSupportUser = !result(this.serverContext, ['CurrentUser', 'Name']).includes('@microsoftsupport.com');
    const isNotE2EMode = !window.navigator.webdriver;
    const isProdUrl = window.location.href.toLocaleLowerCase().includes('https://ui.ads.microsoft.com/');
    const isReportingUrl = window.location.href.includes('campaign/vnext/reports-v4');
    const isWebUICSATSurveyEnabled = window.location.href.includes('isWebUICSATSurveyEnabled=true');

    const qualtricsConditions =
      (this.isTestEnv && isReportingUrl && isWebUICSATSurveyEnabled) || // should be test env
      (isEnglishUser && // should be English user
        isNotInternalUser && // not internal users
        isNotSupportUser && // not support team users
        isNotE2EMode && // not test mode
        isProdUrl && // should be Prod URL
        isReportingUrl // should be Reporitng URL
      );

    if (!qualtricsConditions) {
      if (!isEnglishUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isEnglishUser: ${isEnglishUser}`);
        return false;
      }

      if (!isNotInternalUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotInternalUser: ${isNotInternalUser}`);
        return false;
      }

      if (!isNotSupportUser) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotSupportUser: ${isNotSupportUser}`);
        return false;
      }

      if (!isNotE2EMode) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isNotE2EMode: ${isNotE2EMode}`);
        return false;
      }

      if (!isProdUrl) {
        this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, qualtricsConditions: ${qualtricsConditions}, isProdUrl: ${isProdUrl}`);
        return false;
      }

      return false;
    }

    this.logActivity(`validateTriggerCondition | survey: ${this.getSurveyName()}, Pass. userCreatedDateTime: ${userCreatedDateTime}, surveyPreference30DaysAgo: ${surveyPreference30DaysAgo}`);

    return true;
  };

  getSurveyComponent = () => ReportingWebuiUserSurveyView;

  isReportingPipelineEnabled = () => true;
}
